var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * CameraSwap component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconCameraSwap extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.86327 3C8.63823 3 8.42631 3.10596 8.29129 3.28599L6.15655 6.13231H3.38173C2.77673 6.13231 2.19651 6.37265 1.76872 6.80044C1.34092 7.22824 1.10059 7.80846 1.10059 8.41345V19.3765C1.10059 19.9815 1.34092 20.5618 1.76872 20.9896C2.19651 21.4174 2.77673 21.6577 3.38173 21.6577H20.6094C21.2144 21.6577 21.7947 21.4174 22.2225 20.9896C22.6503 20.5618 22.8906 19.9815 22.8906 19.3765V8.41345C22.8906 7.80846 22.6503 7.22824 22.2225 6.80044C21.7947 6.37265 21.2144 6.13231 20.6094 6.13231H17.8346L15.6999 3.28599C15.5649 3.10596 15.3529 3 15.1279 3H8.86327ZM7.08603 7.27629L9.22077 4.42997H14.7704L16.9051 7.27629C17.0402 7.45632 17.2521 7.56228 17.4771 7.56228H20.6094C20.8352 7.56228 21.0517 7.65196 21.2113 7.81158C21.3709 7.97121 21.4606 8.18771 21.4606 8.41345V19.3765C21.4606 19.6023 21.3709 19.8188 21.2113 19.9784C21.0517 20.138 20.8352 20.2277 20.6094 20.2277H3.38173C3.15598 20.2277 2.93948 20.138 2.77986 19.9784C2.62023 19.8188 2.53055 19.6023 2.53055 19.3765V8.41345C2.53055 8.18771 2.62023 7.97121 2.77986 7.81158C2.93948 7.65196 3.15598 7.56228 3.38173 7.56228H6.51404C6.73909 7.56228 6.951 7.45632 7.08603 7.27629ZM13.0214 8.39176C12.0748 8.1738 11.0841 8.25097 10.1826 8.61289C9.81614 8.76 9.63834 9.17633 9.78545 9.54278C9.93257 9.90922 10.3489 10.087 10.7153 9.93991C11.3458 9.68681 12.0386 9.63285 12.7006 9.78527C13.3626 9.9377 13.962 10.2892 14.4183 10.7925C14.8746 11.2958 15.1658 11.9267 15.2527 12.6005C15.2848 12.8489 15.2885 13.0987 15.2647 13.3453L15.1861 13.2413C14.9479 12.9263 14.4995 12.8641 14.1845 13.1023C13.8696 13.3405 13.8074 13.7889 14.0455 14.1038L15.0416 15.4209C15.2798 15.7359 15.7282 15.7981 16.0431 15.56L17.3603 14.5639C17.6752 14.3257 17.7375 13.8773 17.4993 13.5623C17.309 13.3107 16.9846 13.2204 16.7012 13.3157C16.7194 13.0174 16.7096 12.7167 16.6709 12.4174C16.5466 11.454 16.1302 10.5518 15.4777 9.83206C14.8253 9.11236 13.9681 8.60973 13.0214 8.39176ZM8.86182 10.69C8.7474 10.5387 8.57754 10.4391 8.38963 10.4131C8.20173 10.3871 8.01119 10.4368 7.85995 10.5513L6.54438 11.5474C6.22956 11.7857 6.16758 12.2342 6.40595 12.549C6.59599 12.8 6.91956 12.8903 7.20249 12.7957C7.1842 13.0944 7.19404 13.3955 7.23272 13.6952C7.35706 14.6587 7.77346 15.5609 8.42591 16.2806C9.07836 17.0003 9.93557 17.503 10.8822 17.7209C11.8289 17.9389 12.8196 17.8617 13.7211 17.4998C14.0875 17.3527 14.2653 16.9364 14.1182 16.5699C13.9711 16.2035 13.5548 16.0257 13.1883 16.1728C12.5579 16.4259 11.8651 16.4798 11.2031 16.3274C10.5411 16.175 9.94161 15.8235 9.48534 15.3202C9.02908 14.8169 8.73788 14.1859 8.65093 13.5122C8.61882 13.2634 8.61513 13.0132 8.63903 12.7662L8.71735 12.8697C8.95553 13.1847 9.40393 13.2469 9.71889 13.0087C10.0338 12.7705 10.0961 12.3221 9.85789 12.0072L8.86182 10.69Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconCameraSwap.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconCameraSwap.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconCameraSwap.prototype, "size", void 0);
if (customElements.get('cat-icon-camera-swap') === undefined) {
    customElements.define('cat-icon-camera-swap', BlocksIconCameraSwap);
}
